import { Component, Inject, Input } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-leg-destination',
    templateUrl: './leg-destination.component.html'
})
export class LegDestinationComponent {
    @Input() time: number;
    @Input() delay: number;
    @Input() legName: string;

    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env
    ) {}

    public get isDelayed(): boolean {
        const tresholdEarly = -this.env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_EARLY;
        const tresholdLate = this.env.JOURNEY_PLANNER?.SCHEDULE_TIME_THRESHOLD_LATE;

        return tresholdEarly || tresholdLate
            ? (this.delay || 0) / 60 > tresholdLate || (this.delay || 0) / 60 < tresholdEarly
            : !!this.delay;
    }
}
